import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

/**
 * CTABanner — reusable brand CTA block. Accepts testId.
 */
export default function CTABanner({
    eyebrow = "Let's build what's next",
    title = "Aspire. Design. Execute.",
    subtitle = "Engage our leadership for a working session on your  AI driven roadmap.",
    ctaLabel = "Start a conversation",
    ctaTo = "/contact",
    testId = "cta-banner",
}) {
    return (
        <section
            data-testid={testId}
            className="relative overflow-hidden rounded-3xl glass-strong border border-white/10 p-10 md:p-16"
        >
            <div className="absolute -top-40 -right-40 h-[420px] w-[420px] rounded-full bg-brand-blue/20 blur-3xl" />
            <div className="absolute -bottom-40 -left-40 h-[420px] w-[420px] rounded-full bg-brand-green/15 blur-3xl" />

            <div className="relative flex flex-col md:flex-row md:items-end md:justify-between gap-8">
                <div className="max-w-2xl">
                    <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-brand-green mb-5">
                        <span className="h-px w-6 bg-gradient-to-r from-brand-blue to-brand-green" />
                        {eyebrow}
                    </div>
                    <h3 className="font-display text-3xl md:text-5xl font-bold tracking-tighter leading-[1.05]">
                        {title}
                    </h3>
                    <p className="mt-5 text-zinc-400 text-[15.5px] md:text-[17px] leading-relaxed max-w-lg">
                        {subtitle}
                    </p>
                </div>
                <Link
                    to={ctaTo}
                    data-testid={`${testId}-cta`}
                    className="btn-glow group relative inline-flex items-center gap-2 rounded-full bg-brand-linear px-7 py-4 text-[15px] font-medium text-white shrink-0 hover:shadow-glow-brand transition-all"
                >
                    {ctaLabel}
                    <ArrowUpRight className="h-5 w-5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </Link>
            </div>
        </section>
    );
}
